import { Radio } from "@mantine/core";
import { RadioSurvey } from "../../../components";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <RadioSurvey
      label="¿Como parte de tus actividades tienes contacto con proveedores, clientes, usuarios/as o público en general?"
      {...form.getInputProps("IL_005_contactoConClientes")}
      orientation="vertical"
    >
      <Radio label={`${t("yes")}.`} value="Sí." />
      <Radio label={`${t("no")}.`} value="No." />
    </RadioSurvey>
  );
};

export default Component;
